"use client";
import { useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
const faqs = [
    {
        question: "What is interventional cardiology?",
        answer: "Interventional cardiology is a specialized branch of cardiology that diagnoses and treats heart and blood vessel diseases using catheter-based, minimally invasive procedures instead of open-heart surgery. At HDNA Aarogyam Hospital, these procedures are performed in a state-of-the-art catheterization laboratory.",
    },
    {
        question: "What conditions can be treated with interventional cardiology?",
        answer: "Interventional cardiology can treat several cardiovascular conditions, including:",
        points: [
            "Coronary artery disease (blocked heart arteries)",
            "Heart attacks (acute myocardial infarction)",
            "Peripheral vascular disease",
            "Structural heart defects such as ASD and VSD",
            "Valve disorders like aortic stenosis",
            "Blocked arteries in limbs and organs",
        ],
    },
    {
        question: "What is coronary angioplasty and stenting (PCI)?",
        answer: "Coronary angioplasty, also called Percutaneous Coronary Intervention (PCI), is a minimally invasive procedure used to open blocked coronary arteries. A small balloon and stent are inserted through a catheter to restore normal blood flow to the heart.",
    },
    {
        question: "When should I see an interventional cardiologist?",
        answer: "You should consult an interventional cardiologist if you experience:",
        points: [
            "Chest pain or pressure",
            "Shortness of breath",
            "Fatigue or swelling in the legs",
            "History of heart attack or blocked arteries",
            "Abnormal ECG or echocardiography results",
            "Congenital heart defects"
        ],
        note: "Early evaluation can help prevent serious cardiac complications."
    },
    {
        question: "What is the recovery time after a coronary intervention?",
        answer: "Most patients are discharged within 1–2 days after the procedure and can resume normal daily activities within about one week, depending on the doctor’s advice.",
    },
    {
        question: "Is interventional cardiology safe?",
        answer: "Yes. Interventional cardiology procedures are minimally invasive and generally very safe when performed by experienced specialists using advanced imaging and modern technology.",
    },
    {
        question: "How long does a stent last?",
        answer: "Modern drug-eluting stents are designed to remain effective for many years. Long-term success depends on following prescribed medications, maintaining a healthy lifestyle, and regular follow-up with your cardiologist.",
    },
    {
        question: "Is PCI safe for older patients?",
        answer: "Yes, PCI can be safely performed in elderly patients, but the treatment plan depends on the patient’s overall health condition and evaluation by an interventional cardiologist.",
    },
    {
        question: "Do interventional cardiology procedures require open-heart surgery?",
        answer: "No. Most procedures are performed through small vascular access points in the wrist or groin, using catheters and imaging guidance, eliminating the need for major surgery in many cases.",
    },
    {
        question: "Who performs interventional cardiology procedures at HDNA Aarogyam Hospital?",
        answer: "Interventional procedures at HDNA Aarogyam Hospital are performed by experienced specialists including Dr. Nishant Tripathy and Dr. Ashok Kumar, along with a skilled cardiac care team.",
    }
]
export default function FaqSection() {
    const [activeIndex, setActiveIndex] = useState(null);
    const leftFaqs = faqs.slice(0, 5);
    const rightFaqs = faqs.slice(5, 10);
    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const renderFaqs = (faqList, offset) =>
        faqList.map((faq, index) => {
            const currentIndex = index + offset;
            return (
                <div key={currentIndex} className="faq-box" onClick={() => toggleFaq(currentIndex)} >
                    {/* Question */}
                    <div className={`faq-question ${activeIndex === currentIndex ? "active" : ""}`}>
                        <h6>{faq.question}</h6>
                        <span className="icon"> {activeIndex === currentIndex ? "−" : "+"}</span>
                    </div>
                    {/* Answer */}
                    {activeIndex === currentIndex && (
                        <div className="faq-answer">
                            <p>{faq.answer}</p>

                            {faq.points && (
                                <ul className="faq-points">
                                    {faq.points.map((point, i) => (
                                        <li key={i}>
                                            <span className="point-icon"><MdKeyboardArrowRight /></span> {point}
                                        </li>
                                    ))}
                                </ul>
                            )}

                            {faq.note && <p className="faq-note">{faq.note}</p>}
                        </div>
                    )}
                </div>
            );
        });

    return (
        <section className="faq-section container">
            <div className="row">
                {/* Left Column */}
                <div className="col-lg-6">{renderFaqs(leftFaqs, 0)}</div>
                {/* Right Column */}
                <div className="col-lg-6">{renderFaqs(rightFaqs, 5)}</div>
            </div>
        </section>
    );
}
